export { default, type ExpoDocumentsSectionProps } from './ExpoDocumentsSection';
